/// <reference types="google.maps" />
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GooglePlacesService {
  private googleMapsLoaded: boolean = false;
  private googleMapsLoading: Promise<void> | null = null;
  private GOOGLE_MAPS_API_KEY: string = 'AIzaSyBvi4H-ZLAMaBfarqCcL7qndOTBWNDS0hs';

  constructor(private ngZone: NgZone, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.loadGoogleMaps();
    }
  }

  private loadGoogleMaps(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) {
      // Skip loading on the server
      return Promise.resolve();
    }
    if (this.googleMapsLoaded) {
      return Promise.resolve();
    }

    if (this.googleMapsLoading) {
      return this.googleMapsLoading;
    }

    this.googleMapsLoading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAPS_API_KEY}&loading=async&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.googleMapsLoaded = true;
        this.googleMapsLoading = null;
        resolve();
      };
      script.onerror = () => reject('Google Maps API failed to load.');

      document.body.appendChild(script);
    });

    return this.googleMapsLoading;
  }

  async getPlacePredictions(input: string): Promise<google.maps.places.AutocompletePrediction[]> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.resolve([]);
    }
    await this.loadGoogleMaps();

    return new Promise((resolve, reject): void => {
      const autocompleteService = new google.maps.places.AutocompleteService();

      autocompleteService.getPlacePredictions(
        { input, types: ['geocode'], language: 'en' }, // Force English results
        (predictions: google.maps.places.AutocompletePrediction[] | null, status: google.maps.places.PlacesServiceStatus) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
            this.ngZone.run(() => resolve(predictions));
          } else {
            reject(status);
          }
        }
      );
    });
  }

  async getPlaceDetails(placeId: string): Promise<google.maps.places.PlaceResult> {
    if (!isPlatformBrowser(this.platformId)) {
      return Promise.reject('Google Maps not available on the server');
    }
    await this.loadGoogleMaps();

    return new Promise((resolve, reject) => {
      // const placesService = new google.maps.places.Place(document.createElement('div'));

      // placesService.getDetails(
      //   { placeId },
      //   (result: google.maps.places.PlaceResult | null, status: google.maps.places.PlacesServiceStatus) => {
      //     if (status === google.maps.places.PlacesServiceStatus.OK && result) {
      //       this.ngZone.run(() => resolve(result));
      //     } else {
      //       reject(status);
      //     }
      //   }
      // );

      const place = new google.maps.places.Place({
        id: placeId,
        requestedLanguage: 'en', // optional
        requestedRegion: 'US',   // optional
      });

      place.fetchFields({ fields: ['addressComponents', 'location'] })
        .then((result: any) => {
          this.ngZone.run(() => resolve(result));
        })
        .catch((error: any) => {
          reject(error);
        });

    });
  }
}

